import { FaStar } from "react-icons/fa";

const ListingStars = ({ totalStars }) => {
  if (!totalStars) {
    return null;
  }
  const listOfStars = [];
  for (let i = 0; i < totalStars; i++) {
    listOfStars.push(<FaStar key={i} className="inline-block text-red-400" />);
  }
  return listOfStars;
};

export default ListingStars;
